import React from "react";
import { Modal } from "react-bootstrap";

import { telefonoBonito } from "../../../../utils/telefonoBonito";
import S from "./strings";

/*
	¿Quién firma el contrato? (Esteban, 2026-09-28): para un menor, antes de matricular o de generar el
	contrato de nuevo, se elige cuál contacto de emergencia es su tutor/a legal. En el teléfono ocupa toda
	la pantalla y cada opción es una tarjeta grande.
*/
export interface OpcionTutor { index: number; name: string; relation: string; contact: string }

interface Props {
	show: boolean;
	opciones: OpcionTutor[];
	elegido: number | null;
	countryId?: number;
	movil: boolean;
	onElegir: (index: number) => void;
	onCerrar: () => void;
	onContinuar: () => void;
}

const TutorContratoModal: React.FC<Props> = ({ show, opciones, elegido, countryId, movil, onElegir, onCerrar, onContinuar }) => (
	<Modal className="waModulo waModalArriba" backdropClassName="waFondoArriba" show={show} onHide={onCerrar} centered fullscreen="sm-down">
		<Modal.Header closeButton><Modal.Title style={{ fontSize: 17 }}>{S.tutorTitle}</Modal.Title></Modal.Header>
		<Modal.Body style={{ textAlign: "left", fontSize: 15 }}>
			<div style={{ marginBottom: 12 }}>{S.tutorHint}</div>
			<div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
				{opciones.map((o) => (
					<label key={"tu_" + o.index} style={{ position: "relative", display: "flex", alignItems: "flex-start", gap: 12, margin: 0, cursor: "pointer",
						padding: "12px 14px", borderRadius: 10, border: "1px solid " + (elegido === o.index ? "var(--wa-acento)" : "var(--wa-filo)"),
						background: elegido === o.index ? "var(--wa-acento-suave)" : "transparent" }}>
						<input type="radio" name="tutorContrato" checked={elegido === o.index} onChange={() => onElegir(o.index)}
							style={{ marginTop: 4, width: 18, height: 18, flexShrink: 0, accentColor: "var(--wa-acento)" }} />
						<span style={{ minWidth: 0 }}>
							<b style={{ fontSize: 16, display: "block", overflowWrap: "anywhere" }}>{o.name}</b>
							<span style={{ color: "var(--wa-apagado)", overflowWrap: "anywhere" }}>{[o.relation, telefonoBonito(o.contact, countryId) || o.contact].filter(Boolean).join(" · ")}</span>
						</span>
					</label>
				))}
			</div>
			<div style={{ marginTop: 12, fontSize: 14, color: "var(--wa-apagado)" }}>{S.tutorMissing}</div>
		</Modal.Body>
		<Modal.Footer>
			<button type="button" className="btn btn-primary" style={movil ? { width: "100%", padding: "10px" } : undefined} disabled={elegido === null} onClick={onContinuar}>{S.tutorContinue}</button>
		</Modal.Footer>
	</Modal>
);

export default TutorContratoModal;
